
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function ImpactHeroSection() {
  const navigate = useNavigate();

  const scrollToRoadmap = () => {
    const roadmapSection = document.getElementById('roadmap-section');
    if (roadmapSection) {
      roadmapSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  const joinMission = () => {
    navigate('/donate');
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/7e54c69c746a7001b4a777ccbd6a479f.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Overlay for better text contrast */}
      <div className="absolute inset-0 bg-white/90"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center max-w-4xl mx-auto">
          <div className="space-y-8">
            <div className="space-y-6">
              <div className="inline-flex items-center px-4 py-2 bg-[#12B6B6]/10 rounded-full">
                <i className="ri-compass-line w-5 h-5 flex items-center justify-center text-[#12B6B6] mr-2"></i>
                <span className="text-sm font-medium text-[#12B6B6]">Building the Future</span>
              </div>
              
              <h1 className="text-5xl md:text-7xl font-bold text-[#111111] leading-tight">
                Our Commitment
                <br />
                <span className="text-[#12B6B6]">to Impact</span>
              </h1>
              
              <p className="text-xl md:text-2xl text-gray-700 leading-relaxed max-w-3xl mx-auto">
                We measure impact through lives reached, awareness created, and access enabled.
                Every program is designed to create long-term community benefit, not short-term intervention.
              </p>

              {/* Donor-friendly line */}
              <p className="text-base text-[#12B6B6] font-medium italic max-w-2xl mx-auto border-l-4 border-[#12B6B6] pl-4 text-left">
                We are committed to transparent reporting and measurable outcomes for all partners and supporters.
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={scrollToRoadmap}
                className="inline-flex items-center justify-center font-medium rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer bg-[#12B6B6] text-white hover:bg-[#0ea5a5] shadow-lg hover:shadow-xl px-8 py-4 text-lg"
              >
                View Our Roadmap
              </button>
              <button
                onClick={joinMission}
                className="inline-flex items-center justify-center font-medium rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer bg-[#111111] text-white hover:bg-gray-800 shadow-lg hover:shadow-xl px-8 py-4 text-lg"
              >
                Join Our Mission
              </button>
            </div>
            
            {/* Foundation Principles */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
              <div className="text-center">
                <div className="w-16 h-16 mx-auto mb-4 bg-[#12B6B6]/10 rounded-2xl flex items-center justify-center">
                  <i className="ri-eye-line w-8 h-8 flex items-center justify-center text-[#12B6B6]"></i>
                </div>
                <h3 className="text-lg font-semibold text-[#111111] mb-2">Transparent</h3>
                <p className="text-sm text-gray-600">Every rupee tracked and reported</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 mx-auto mb-4 bg-[#12B6B6]/10 rounded-2xl flex items-center justify-center">
                  <i className="ri-bar-chart-line w-8 h-8 flex items-center justify-center text-[#12B6B6]"></i>
                </div>
                <h3 className="text-lg font-semibold text-[#111111] mb-2">Measurable</h3>
                <p className="text-sm text-gray-600">Data-driven impact assessment</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 mx-auto mb-4 bg-[#12B6B6]/10 rounded-2xl flex items-center justify-center">
                  <i className="ri-community-line w-8 h-8 flex items-center justify-center text-[#12B6B6]"></i>
                </div>
                <h3 className="text-lg font-semibold text-[#111111] mb-2">Community-Driven</h3>
                <p className="text-sm text-gray-600">Powered by local partnerships</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
